import {
  Component,
  ElementRef,
  EventEmitter,
  Input, OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {MaplistModel} from "../../shared/models/project-details/map.model";
import {ApiService} from "../../core/api/api.service";

@Component({
    selector: 'bergh-map-replacement-operation',
    templateUrl: './map-replacement-operation.component.html',
    styleUrls: ['./map-replacement-operation.component.scss'],
    standalone: false
})
export class MapReplacementOperationComponent implements OnInit {
  @ViewChild('oldmap') public oldMapRef: ElementRef;
  @ViewChild('newmap') public newMapRef: ElementRef;
  @Input() isReplace: boolean;
  @Input() oldMap: MaplistModel;
  @Output() updatedList: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  public oldimgsrc: string;
  public newimgsrc: any;
  public loading: boolean = false;

  public file = null;
  public uploadFile = null;
  public uploadFileName = '';
  public isUploaded: boolean = false;
  public isReplaced: boolean = false;
  newFlag: boolean;
  constructor(private toastr: ToastrService, private _api: ApiService) {}

  ngOnInit(): void {
    this.oldimgsrc = this.oldMap.image;
  }

  public onUploadSelectFile(e): void {
    const FILE = <File>e.target.files[0];
    const FORMATS = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'application/pdf',
      'image/x-dwg',
      'application/acad',
      'application/x-acad',
      'application/autocad_dwg',
      'image/x-dwg',
      'application/dwg',
      'application/x-dwg',
      'application/x-autocad',
      'image/vnd.dwg',
      'drawing/dwg',
    ];
    if (FORMATS.includes(FILE.type) || FILE.name.includes('.dwg')) {
      if (FILE.size <= 15000000) {
        this.uploadFile = FILE;

        this.uploadFileName = FILE.name;
        if (FILE.type === 'application/pdf' || FILE.name.includes('.dwg')) {
          this.loading = true;
          let form = new FormData();
          form.append('plan', this.uploadFile);
          this._api.request('convertMap', form).subscribe(
            (res: any) => {
              this.newimgsrc = res.imageUrl;
              this.loading = false;
            },
            (error: any) => {
              console.error(error)
              this.loading = false;
            }
          );
        } else {
          this.loading = true;
          const reader = new FileReader();
          reader.readAsDataURL(this.uploadFile);
          reader.onload = (_event) => {
            this.newimgsrc = reader.result;
            const img = new Image();
            img.src = this.newimgsrc;
            this.newFlag = true;
          };

          this.loading = false;
        }
      } else {
        this.uploadFile = null;
        this.uploadFileName = '';
        this.toastr.warning('De bestandsgrootte moet kleiner zijn dan 15 MB');
      }
    } else {
      this.toastr.warning(
        'Je kunt alleen bestanden uploaden met de extensie .png, .jpg, .jpeg, .pdf, .dwg',
        'Error'
      );
    }
  }

  public isMapUploaded(showTool: boolean): void {
    this.isUploaded = showTool;
  }

  public close(): void {
    this.cancel.emit();
  }

  public saveImage(image: any): void {
    this.loading = true;
    if (
      this.uploadFileName.includes('.pdf') ||
      this.uploadFileName.includes('.dwg')
    ) {
      this.uploadFileName = this.uploadFileName.split('.')[0] + '.jpg';
    }
    const file = this.dataURIToBlob(image);
    const formData = new FormData();
    formData.append('plan', file, this.uploadFileName);
    this._api
      .request('replaceMap', formData, `${this.oldMap._id}/upload`)
      .subscribe(() => {
        this.toastr.success('Kaart succesvol vervangen');
        this.updatedList.emit(true);
        this.loading = false;
      });
  }

  public replaceMap(): void {
    this.isReplaced = true;
  }

  private dataURIToBlob(dataURI: string): Blob {
    const splitDataURI = dataURI.split(',');
    const byteString =
      splitDataURI[0].indexOf('base64') >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);

    return new Blob([ia], { type: mimeString });
  }
}
